export default class DatalayerComponent {
    constructor() {
        DatalayerComponent.form_submit()
    }

    static form_submit() {
        $('.frm_forms form').each(function () {
            const form = $(this)
            const formId = form.attr('id');

            if (formId) {
                $(this).on('submit', function () {
                    let formData = [];
                    const inputs = form.find("input, select, textarea");

                    inputs.each(function () {
                        const $this = $(this);
                        const input = {
                            id: $this.attr('id'),
                            value: $this.val(),
                            type: $this.attr('type'),
                            checked: $this.prop('checked')
                        };

                        if (input.type !== "submit" && input.id) {
                            let data = null;

                            if (input.type === 'radio') {
                                if (input.checked) {
                                    const label = document.querySelector('[id="' + input.id.split('-')[0] + '_label"]');
                                    if (label) {
                                        data = {
                                            name: label.innerText.replace(/\*/g, '').trim(),
                                            value: input.value
                                        };
                                    } else {
                                        data = {
                                            name: $this.attr('name'),
                                            value: input.value
                                        };
                                    }
                                }
                            } else if (input.type === 'checkbox') {
                                if (input.checked) {
                                    const label = document.querySelector('[for="' + input.id + '"]');
                                    if (label) {
                                        data = {
                                            name: label.innerText.replace(/\*/g, '').trim(),
                                            value: 1
                                        };
                                    } else {
                                        data = {
                                            name: $this.attr('name'),
                                            value: 1
                                        };
                                    }

                                }
                            } else {
                                const label = document.querySelector('[for="' + input.id + '"]');
                                if (label) {
                                    const labelFormatted = label.innerText.replace(/\*/g, '').trim();
                                    if (labelFormatted) {
                                        data = {
                                            name: labelFormatted,
                                            value: input.value
                                        };
                                    } else {
                                        data = {
                                            name: $this.attr('name'),
                                            value: input.value
                                        };
                                    }
                                } else {
                                    data = {
                                        name: $this.attr('name'),
                                        value: input.value
                                    };
                                }
                            }

                            if (data && (input.value || input.checked)) {
                                formData.push(data);
                            }
                        }
                    });

                    const formName = $(this).attr('id');
                    console.log({
                        "event": 'form_submitted_' + formName,
                        "formId": formName,
                        "response": formData
                    });
                    window.dataLayer.push({
                        "event": 'form_submitted_' + formName,
                        "formId": formName,
                        "response": formData
                    });
                });
            }
        });
    }

    static formatString(string) {
        // Check is a string
        if (
            (typeof string === 'string' && !string.trim()) ||
            typeof string === 'undefined' ||
            string === null
        ) {
            return null
        }

        // Remove accent
        let cleanString = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

        // Transform in lower case
        cleanString = cleanString.toLowerCase()

        return cleanString
    }
}
